import React from "react";
import { useTranslation } from "react-i18next";

const ProspectGeneralStats = ({ generalStats, userRole }) => {
  const { t } = useTranslation("common");
  const currentYear = new Date().getFullYear();
  return (
    <div className="row flex-nowrap g-3 pt-3 pb-5 overflow-auto">
      {generalStats.map(({ label, value, bgColor, showYear, roles }) => {
        const show = roles?.length > 0 ? roles?.includes(userRole) : true;
        if (!show) return null;
        return (
          <div className="col-3">
            <div
              key={label}
              className={`p-3 px-4 br20 flex-1 flex-column h-100`}
              style={{
                backgroundColor: bgColor,
              }}
            >
              <span className="d-block text-white sBold f20 mb-1">
                {t(`${label}`)} {showYear ? currentYear : ""}
              </span>
              <span className="d-block text-white text-nowrap bold f33">
                {value ?? 0}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ProspectGeneralStats;
